import type { Paragraph } from 'mdast';
import type { State } from '../state';

export function paragraph(state: State, node: Paragraph): void {
	const nodeType = state.schema.nodes.paragraph;
	if (!nodeType) {
		// Gracefully degrade: schema has no paragraph node — render inline children directly
		state.parseTokens(node.children);
		return;
	}
	state.openNode(nodeType);
	state.parseTokens(node.children);
	state.closeNode();
}
